import { default as Scene0 } from './Scene0';
import { default as Scene1 } from './Scene1';
import { default as Scene2 } from './Scene2';
import { default as Scene3 } from './Scene3';
import { default as Scene4 } from './Scene4';
import { default as Scene5 } from './Scene5';
import { default as Scene6 } from './Scene6';
import { default as Scene7 } from './Scene7';
import { default as Scene8 } from './Scene8';
import { default as Scene9 } from './Scene9';
import { default as Scene10 } from './Scene10';
import { default as Scene11 } from './Scene11';
import { default as Scene12 } from './Scene12';
import { default as Scene13 } from './Scene13';

const scenes = [Scene0, Scene1, Scene2, Scene3, Scene4, Scene5, Scene6, Scene7, Scene8, Scene9, Scene10, Scene11, Scene12, Scene13];
export default scenes;
